import { FC, useEffect, useState } from 'react';
import { DSOProductListingProps } from '.';
import { useDsoToggleFavourites } from 'reactQuery/mutations/dso/useDsoToggleFavourites';
import { Styled } from '.';
import { SortDirection } from 'types';
import { FilterModal, ProductListing } from 'components';
import { useApplyFacetFilterFromURL } from 'utils/hooks';
import AppliedFilterList from 'components/ProductListing/AppliedFilterList';
import { Button, DsoLoadingSpinner } from 'components/core';
import { MdFilterList } from 'react-icons/md';
import { AppliedFacetFilter } from 'components/FacetFilters';
import { useRouter } from 'next/router';

export const DSOProductListing: FC<DSOProductListingProps> = ({
  productListData,
  permalink,
  title,
  showFilters = true,
  sortDirection,
  setSortDirection,
}) => {
  // const [sortDirection, setSortDirection] = useState<SortDirection | ''>('');
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const router = useRouter();

  const {
    appliedFacetFilters,
    onSelectFacetFilter,
    onRemoveFacetFilter,
    onRemoveAllFacetFilter,
  } = useApplyFacetFilterFromURL();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [appliedFacetFilters]);

  const handleApplyFilters = (
    filters: AppliedFacetFilter[],
    sort: SortDirection | ''
  ) => {
    // Apply sort
    setSortDirection(sort);

    // Build query params from all filters at once
    const filterQueryParams = filters.reduce(
      (acc: { [key: string]: string }, filter: AppliedFacetFilter) => {
        if (acc[filter.filterKey]) {
          // If filter key already exists, append with comma
          acc[filter.filterKey] =
            acc[filter.filterKey] + ',' + filter.filterValue;
        } else {
          // Create new filter key
          acc[filter.filterKey] = filter.filterValue;
        }
        return acc;
      },
      {}
    );

    // Apply all filters at once with a single router push
    router.push(
      {
        ...router,
        query: {
          slug: router.query.slug,
          ...filterQueryParams,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <>
      <Styled.ProductListingHeader>
        <Styled.TaxonTitle>{title}</Styled.TaxonTitle>
        {showFilters && (
          <Button onClick={() => setIsFilterModalOpen(true)}>
            <MdFilterList size={24} />
            <span>Filters</span>
          </Button>
        )}
      </Styled.ProductListingHeader>

      {showFilters && (
        <AppliedFilterList
          allFilters={productListData.data?.pages[0]?.aggregations}
          appliedFilters={appliedFacetFilters}
          removeFilter={onRemoveFacetFilter}
          clearAllFilters={onRemoveAllFacetFilter}
        />
      )}
      <Styled.Main>
        {productListData.isLoading || productListData.isIdle ? (
          <DsoLoadingSpinner />
        ) : (
          <Styled.ProductListingBodyWrapper>
            <ProductListing productList={productListData} />
          </Styled.ProductListingBodyWrapper>
        )}
      </Styled.Main>

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        aggregations={productListData.data?.pages[0]?.aggregations}
        appliedFacetFilters={appliedFacetFilters}
        sortDirection={sortDirection ?? ''}
        onApplyFilters={handleApplyFilters}
      />
    </>
  );
};
